import * as tslib_1 from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import ScrollAware from '../ScrollAware';
import s from './Sticky.scss';
import { PerspectiveContext } from '../Context';
var Sticky = /** @class */ (function (_super) {
    tslib_1.__extends(Sticky, _super);
    function Sticky() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            minHeight: 0,
        };
        _this.rootRef = React.createRef();
        _this.innerRef = React.createRef();
        return _this;
    }
    Sticky.prototype.componentDidMount = function () {
        this.setState({
            minHeight: this.minHeight,
        });
    };
    Sticky.prototype.componentDidUpdate = function (prevProps, prevState) {
        var minHeight = this.minHeight;
        if (prevState.minHeight !== this.state.minHeight) {
            this.setState({ minHeight: minHeight });
        }
    };
    Sticky.prototype.isStuck = function (scrollTop) {
        if (!this.rootRef.current) {
            return false;
        }
        var marginTop = this.props.marginTop || 0;
        var rect = this.rootRef.current.getBoundingClientRect();
        return rect.top - marginTop <= 0;
    };
    Sticky.prototype.getTop = function (_a) {
        var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, bodyWidth = _a.bodyWidth;
        var _b = this.props, bottomStop = _b.bottomStop, _c = _b.marginTop, marginTop = _c === void 0 ? 0 : _c;
        var bottom = typeof bottomStop === 'function'
            ? bottomStop(bodyWidth)
            : bottomStop || 0;
        if (bottom === 0) {
            return 0;
        }
        var minHeight = this.state.minHeight;
        var diff = scrollHeight - scrollTop - minHeight - marginTop - bottom;
        return diff < 0 ? diff : 0;
    };
    Object.defineProperty(Sticky.prototype, "minHeight", {
        get: function () {
            return ((this.innerRef.current &&
                +this.innerRef.current.getBoundingClientRect().height) ||
                0);
        },
        enumerable: true,
        configurable: true
    });
    Sticky.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: this.rootRef, style: {
                minHeight: this.state.minHeight,
            } },
            React.createElement(PerspectiveContext.Consumer, null, function (_a) {
                var getZeroPerspectiveContainer = _a.getZeroPerspectiveContainer;
                return (React.createElement(ScrollAware, null, function (_a) {
                    var scrollTop = _a.scrollTop, bodyWidth = _a.bodyWidth, scrollHeight = _a.scrollHeight;
                    var isStuck = _this.isStuck(scrollTop);
                    var zeroPerspectiveContainer = getZeroPerspectiveContainer();
                    if (isStuck && zeroPerspectiveContainer) {
                        return ReactDOM.createPortal(_this.renderInnerDiv({
                            isStuck: isStuck,
                            top: _this.getTop({
                                scrollTop: scrollTop,
                                bodyWidth: bodyWidth,
                                scrollHeight: scrollHeight,
                            }),
                        }), zeroPerspectiveContainer);
                    }
                    else {
                        return _this.renderInnerDiv({ isStuck: isStuck, top: 0 });
                    }
                }));
            })));
    };
    Sticky.prototype.renderInnerDiv = function (_a) {
        var isStuck = _a.isStuck, top = _a.top;
        var className = this.props.className;
        var marginTop = this.props.marginTop || 0;
        return (React.createElement("div", { className: classnames(s['content'], isStuck && s['stuck'], isStuck && className), style: {
                zIndex: this.props.zIndex,
                marginTop: isStuck && marginTop + (marginTop ? 'px' : ''),
                top: isStuck && top ? top + "px" : undefined,
            }, ref: this.innerRef }, this.props.children(isStuck)));
    };
    return Sticky;
}(React.Component));
export default Sticky;
//# sourceMappingURL=Sticky.js.map